const equipmenttypes = {
	title: "Utstyrstyper",
	stitle: "Utstyrstype",
	new_title: "Ny utstyrstype",
	edit_title: "Endre utstyrstype: {name}",
	list_title: "Utstyrstyper",
	list_subtitle: "Endre utstyrstype",
	id: "ID",
	name: "Navn",
	status: "Status",
	reference_id: "Referanse",
	inspection_interval: "Kontrollintervall",
};
export default equipmenttypes;